class Cart {
  product_id = 0

  num = 0

  custom_name = ''

  custom_phone = ''

  remark = ''

  source = ''

  product = null

  total_price = 0

  constructor (data = {}) {
    this.setData(data)
    if (this.product && this.product.id) this.product_id = this.product.id
  }

  /**
   * 设置属性
   * @param  Object  obj  属性对象, 如: {id: 10001}
   * @return Class   this
  */
  setData (obj = {}) {
    Object.keys(obj).forEach((k) => {
      if (typeof obj[k] !== 'function') this[k] = obj[k]
    })
    return this
  }

  plus () {
    this.num += 1
    this.calculate()
    return this
  }

  minus () {
    if (this.num > 1) {
      this.num -= 1
    }
    this.calculate()
  }

  calculate () {
    this.total_price = Number(this.num) * Number(this.product.reserve_price)
    return this
  }

  invalid () {
    if (!this.custom_name || this.custom_name.length < 2) return '请填写订购人姓名'
    if (!this.custom_phone) return '请填写订购人手机号'
    if (this.custom_phone.length < 11) return '请填写正确的手机号'
  }
}

export default Cart
